import { Extension } from '@tiptap/core';
import { Plugin, PluginKey } from '@tiptap/pm/state';
import { ReplaceStep } from '@tiptap/pm/transform';
import { isRemoteYjsTransaction } from './is-remote-yjs-transaction';
export const AutomaticReplacements = Extension.create({
    name: 'automaticReplacements',
    addOptions() {
        return {
            getSetting: undefined,
        };
    },
    addProseMirrorPlugins() {
        const getSetting = this.options.getSetting || (() => []);
        return [
            new Plugin({
                key: new PluginKey('automaticReplacements'),
                appendTransaction: (transactions, _oldState, newState) => {
                    const replacements = getSetting();
                    if (!replacements || replacements.length === 0) {
                        return null;
                    }
                    const sortedReplacements = [...replacements].sort((a, b) => b[0].length - a[0].length);
                    const shouldProcess = transactions.some((tr) => {
                        if (tr.getMeta('automaticReplacements') || tr.getMeta('hyphenToDash') || tr.getMeta('collapseSpaces')) {
                            return false;
                        }
                        if (tr.getMeta('undo') || tr.getMeta('redo') || tr.getMeta('addToHistory') === false) {
                            return false;
                        }
                        if (isRemoteYjsTransaction(tr)) {
                            return false;
                        }
                        return tr.docChanged;
                    });
                    if (!shouldProcess) {
                        return null;
                    }
                    try {
                        const docSize = newState.doc.content.size;
                        const tr = newState.tr;
                        const replacementsToApply = [];
                        const safeTextBetween = (from, to, defaultText = '') => {
                            try {
                                if (from < 0 || to < 0 || from > docSize || to > docSize || from > to) {
                                    return defaultText;
                                }
                                return newState.doc.textBetween(from, to, '');
                            }
                            catch (error) {
                                return defaultText;
                            }
                        };
                        const maxReplacementLength = sortedReplacements.length > 0
                            ? Math.max(...sortedReplacements.map(([from]) => from.length))
                            : 0;
                        transactions.forEach((transaction) => {
                            if (!transaction.docChanged || isRemoteYjsTransaction(transaction)) {
                                return;
                            }
                            transaction.steps.forEach((step, stepIndex) => {
                                try {
                                    if (step instanceof ReplaceStep) {
                                        const from = step.from;
                                        const to = step.to;
                                        const slice = step.slice;
                                        if (from < 0 || to < 0 || from > docSize || to > docSize) {
                                            return;
                                        }
                                        const isDeletion = from < to && slice.content.size === 0;
                                        const hasInsertedText = slice && slice.content.size > 0;
                                        if (!isDeletion && hasInsertedText) {
                                            let insertedText = '';
                                            let insertEnd = to;
                                            if (from === to) {
                                                try {
                                                    insertedText = slice.content.textBetween(0, slice.content.size, '');
                                                    insertEnd = from + slice.content.size;
                                                }
                                                catch (error) {
                                                    insertedText = safeTextBetween(from, from + slice.content.size);
                                                    insertEnd = from + slice.content.size;
                                                }
                                            }
                                            else {
                                                insertedText = safeTextBetween(from, to);
                                                insertEnd = to;
                                            }
                                            if (insertedText.length > 0) {
                                                const scanStart = Math.max(0, from - maxReplacementLength);
                                                const scanEnd = insertEnd;
                                                const processedPositions = new Set();
                                                let searchPos = scanStart;
                                                while (searchPos < scanEnd && searchPos < docSize) {
                                                    if (processedPositions.has(searchPos)) {
                                                        searchPos += 1;
                                                        continue;
                                                    }
                                                    let matched = false;
                                                    for (const [fromPattern, toPattern] of sortedReplacements) {
                                                        if (fromPattern.length === 0) {
                                                            continue;
                                                        }
                                                        const checkEnd = searchPos + fromPattern.length;
                                                        if (checkEnd > docSize) {
                                                            continue;
                                                        }
                                                        const textAtPos = safeTextBetween(searchPos, checkEnd);
                                                        if (textAtPos === fromPattern) {
                                                            replacementsToApply.push({
                                                                pos: searchPos,
                                                                from: fromPattern,
                                                                to: toPattern,
                                                            });
                                                            for (let i = 0; i < fromPattern.length; i++) {
                                                                processedPositions.add(searchPos + i);
                                                            }
                                                            searchPos += fromPattern.length;
                                                            matched = true;
                                                            break;
                                                        }
                                                    }
                                                    if (!matched) {
                                                        searchPos += 1;
                                                    }
                                                }
                                            }
                                        }
                                    }
                                    else {
                                        const stepType = step.constructor.name;
                                        if (stepType.includes('Replace') || step.from !== undefined) {
                                            const stepAny = step;
                                            if (stepAny.from !== undefined && stepAny.to !== undefined) {
                                                const from = stepAny.from;
                                                const to = stepAny.to;
                                                if (from < 0 || to < 0 || from > docSize || to > docSize) {
                                                    return;
                                                }
                                                const slice = stepAny.slice;
                                                const isDeletion = from < to && (slice === undefined || slice.content === undefined || slice.content.size === 0);
                                                if (!isDeletion) {
                                                    const insertedText = safeTextBetween(from, to);
                                                    if (insertedText.length > 0) {
                                                        const scanStart = Math.max(0, from - maxReplacementLength);
                                                        const scanEnd = to;
                                                        const processedPositions = new Set();
                                                        let searchPos = scanStart;
                                                        while (searchPos < scanEnd && searchPos < docSize) {
                                                            if (processedPositions.has(searchPos)) {
                                                                searchPos += 1;
                                                                continue;
                                                            }
                                                            let matched = false;
                                                            for (const [fromPattern, toPattern] of sortedReplacements) {
                                                                if (fromPattern.length === 0) {
                                                                    continue;
                                                                }
                                                                const checkEnd = searchPos + fromPattern.length;
                                                                if (checkEnd > docSize) {
                                                                    continue;
                                                                }
                                                                const textAtPos = safeTextBetween(searchPos, checkEnd);
                                                                if (textAtPos === fromPattern) {
                                                                    replacementsToApply.push({
                                                                        pos: searchPos,
                                                                        from: fromPattern,
                                                                        to: toPattern,
                                                                    });
                                                                    for (let i = 0; i < fromPattern.length; i++) {
                                                                        processedPositions.add(searchPos + i);
                                                                    }
                                                                    searchPos += fromPattern.length;
                                                                    matched = true;
                                                                    break;
                                                                }
                                                            }
                                                            if (!matched) {
                                                                searchPos += 1;
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                                catch (error) {
                                    console.error(`[AutomaticReplacements] Error processing step ${stepIndex}:`, error);
                                }
                            });
                        });
                        if (replacementsToApply.length > 0) {
                            replacementsToApply.reverse().forEach(({ pos, from, to }) => {
                                try {
                                    if (pos >= 0 && pos + from.length <= docSize) {
                                        tr.replaceWith(pos, pos + from.length, newState.schema.text(to));
                                    }
                                }
                                catch (error) {
                                    console.error(`[AutomaticReplacements] Error replacing at position ${pos}:`, error);
                                }
                            });
                            tr.setMeta('automaticReplacements', true);
                            return tr;
                        }
                        return null;
                    }
                    catch (error) {
                        console.error('[AutomaticReplacements] Error in appendTransaction:', error);
                        return null;
                    }
                },
            }),
        ];
    },
});
//# sourceMappingURL=automatic-replacements.js.map